import '../../styles/external/select2.min.css';
import '../../styles/external/flexslider.css';

import '../../styles/advance_dealer/advance-dealer-common.scss';

import '../external/lazysizes.min.js';
import '../external/jquery.flexslider-min';
import '../components/common_ad_detail';
import '../components/ad_contact_request';
import '../components/image_slider';
import '../components/share_link_by_email';
import '../components/ad_insurance';
import '../components/compare_finance_options';

import './advance_dealer.js';

const energyGrade = {
    expandGradeSection() {
        let $expandGradeSection = $('.expandGradeSection');
        let gradeNumber = $expandGradeSection.data('grade-number') || '';
        let co2Emission = $expandGradeSection.data('co2-emission') || '';
        let appendElement = `<div id="appendGrade">${co2Emission}</div>`;
        $('.co2-information__bars-block div[class^="co2-information__bars-row_"]').each(function () {
            $(this).removeClass('active-bar');
            // Remove old appendGrade element
            if ($(this).children('#appendGrade').length > 0) {
                $(this).children('#appendGrade').remove();
            }

            if ($(this).attr('class').match(`co2-information__bars-row_${gradeNumber}`)) {
                $(this).addClass('active-bar').append(appendElement);
            }
        });

        let $co2Information = $('.co2Information');
        $co2Information.toggle();
        if ($co2Information.is(':visible')) {
            $('#energyGradeMainSection').addClass('co2-information__open');
        } else {
            $('#energyGradeMainSection').removeClass('co2-information__open');
        }
    },
};

$(function () {
    let $body = $('body');

    // Show energy grade section
    $body.on('click', '.expandGradeSection', function () {
        energyGrade.expandGradeSection();
    });
});
